function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmonstrNavigation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m5.5 10.375 13-4.875-4.867 13L12 12Z",
    style: {
      fill: "#fff",
      fillopacity: 1,
      stroke: "none",
      strokeWidth: 0.54166663
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrNavigation1);
export default __webpack_public_path__ + "static/media/iconmonstr-navigation-1.e5d8eed84511eb59e1cb963de1d23a27.svg";
export { ForwardRef as ReactComponent };